import { h } from "preact";
import { useRef, useState } from "preact/hooks";

export default function AnimatedCheckmark({ checked, className = "" }) {
  const [closing, setClosing] = useState(false);
  const componentRef = useRef(null);

  const handleTransitionEnd = (e) => {
    if (!componentRef?.current) return;
    if (componentRef.current !== e.target) return;

    setClosing(checked);
  };

  return (
    <div
      className={`${className} animated-checkmark ${checked ? "animated-checkmark--checked" : ""} ${closing ? "animated-checkmark--closing" : ""}`}
      onTransitionEnd={handleTransitionEnd}
      ref={componentRef}
    >
      <div className="animated-checkmark__icon-wrapper">
        <svg
          className="animated-checkmark__icon animated-checkmark__icon--plus"
          width="21"
          height="22"
          viewBox="0 0 21 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.625 14.0623L11.3947 14.0625L11.3947 18.0004L9.625 18.0002L9.625 14.0623Z"
            fill="currentColor"
          />
          <path
            d="M9.625 4H11.375V10.1249L17.5 10.125V11.8461L3.5 11.8461V10.125H9.625V4Z"
            fill="currentColor"
          />
        </svg>
      </div>
      <div className="animated-checkmark__icon-wrapper">
        <svg
          className="animated-checkmark__icon animated-checkmark__icon--check"
          width="23"
          height="24"
          viewBox="0 0 23 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.67741 10.8435L4.13159 12.3835L9.30151 17.5263L18.8684 8.0193L17.3226 6.47363L9.30151 14.4406L5.67741 10.8435Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </div>
  );
}
